import {
  createEffect,
  createEvent,
  createStore,
  forward,
  sample,
} from 'effector';
import { delay } from 'shared/lib/delay';

export type Notification = {
  id: number;
  message: string;
  variant: 'success' | 'info' | 'warning' | 'error';
  timeout?: number;
};

type Notify = Omit<Notification, 'id'>;

export const $notifications = createStore<Notification[]>([], {
  name: 'notifications',
});

export const notify = createEvent<Notify>('notify');
export const cancel = createEvent<number>('cancel');
const timeoutFx = createEffect<(notify: Notification) => Promise<number>>(
  ({ id, timeout = 5000 }) => delay(timeout, id),
);

const id = createStore(0).on(notify, (prev) => prev + 1);

const newNotification = sample({
  source: id,
  clock: notify,
  fn: (id, notify) => ({ id, ...notify }),
});

forward({ from: newNotification, to: timeoutFx });
forward({ from: timeoutFx.doneData, to: cancel });

$notifications.on(newNotification, (state, el) => [...state, el]);
$notifications.on(cancel, (state, id) => state.filter((el) => el.id !== id));

export const createNotify = (config: Notify) => notify.prepend(() => config);
